module.exports = {
      id: "comm-science-usage",
      viewBox: "0 0 366.545 49.888",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-science",
      toString: function () {
        return this.url;
      }
    }